import { Loader2 } from 'lucide-react';
import { ReneoLogo as SharedReneoLogo } from '@/shared/components/ReneoLogo';
import { AuthorizationShell } from './AuthorizationShell';

export function AuthorizationLoadingScreen() {
    return (
        <AuthorizationShell>
            <div className="mx-auto flex w-full max-w-sm flex-col items-center justify-center gap-8 text-center">
                <SharedReneoLogo size="md" variant="full" className="w-[180px]" />
                <div className="space-y-3">
                    <h2 className="text-3xl font-semibold tracking-tight text-gray-900">Checking your session</h2>
                    <p className="text-base leading-relaxed text-gray-600">We&apos;re preparing your workspace and confirming your access.</p>
                </div>
                <div className="flex items-center gap-3 rounded-full border border-[#004D57]/15 bg-[#004D57]/5 px-5 py-3 text-sm font-medium text-[#004D57]">
                    <Loader2 className="h-4 w-4 animate-spin" />
                    Loading authentication state
                </div>
            </div>
        </AuthorizationShell>
    );
}
